import { sortByLabelAsc } from "./sort-by-prop";

/**
 * Merge right to left, but don't overwrite higher priority values.
 * undefined < null < value.
 *
 * @param {Object} target - Target object.
 * @param {Object} args - Objects to merge.
 * @return {*} - Merged result.
 */
function priorityMerge(target, ...args) {
  args.forEach((obj) => {
    Object.entries(obj).forEach(([k, right]) => {
      const left = target[k];

      switch (right) {
        case undefined:
          if (left === undefined) {
            target[k] = undefined;
          }
          break;
        case null:
          if (left === undefined) {
            target[k] = null;
          }
          break;
        default:
          target[k] = right;
          break;
      }
    });
  });

  return target;
}

function defaultFormatter(model) {
  return model.name;
}

function getSelectOptions(models, formatter = defaultFormatter) {
  return Object.values(models)
    .map((model) => ({ value: model.id, label: formatter(model) }))
    .sort(sortByLabelAsc);
}

function transformValues(obj, mapper) {
  if (!obj) {
    return {};
  }

  function transform(v, mapper) {
    if (typeof v === "object") {
      return transformValues(v, mapper);
    }
    return mapper(v);
  }

  return Object.entries(obj).reduce((acc, [k, v]) => {
    if (Array.isArray(v)) {
      acc[k] = v.map((val) => {
        return transform(val, mapper);
      });
    } else {
      acc[k] = transform(v, mapper);
    }

    return acc;
  }, {});
}

export { defaultFormatter, priorityMerge, getSelectOptions, transformValues };
